import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  riskDataService,
  assetDataService,
  riskSharedModelService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './assign-top-risk-types-dialog.controller';
import template from './assign-top-risk-types-dialog.html';
import riskType from '../../../riskAdministration/riskType';
import editRiskTypeDialog from '../../../../global/editRiskTypeDialog';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    assetType,
    riskTypes,
  }) {
    return {
      controller,
      controllerAs: 'assignTopRiskTypesDialogVM',
      locals: {
        assetType,
        riskTypes,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.assetAdministration.assignTopRiskTypesDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  riskDataService,
  assetDataService,
  riskSharedModelService,
  editRiskTypeDialog,
  copy,
  alerts,
  riskType,
])
  .service('assignTopRiskTypesDialog', dialogService)
  .name;

console.log('app.components.admin.assetAdministration.assignTopRiskTypesDialog created');
